/**
 * @Description 经营门店
 */

import { FC, useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import Search from './components/Search';
import TableList from './components/TableList';
import { useMethods } from '@lhb/hook';
// import { useBigdataFn } from '@/common/utils/bigdata';
import { famousBrandDataListShare, spotEvaluationLevelPage, spotEvaluationLevelPageShare, surroundCompetitorsPagePOIDataListShare, getSpotEvaluationFamousBrandPage, postSpotEvaluationCompetitorsPage } from '@/common/api/spotevaluation';
import { SpotTypeEnum } from '@/views/spotevaluation/pages/index/ts-config';
import { isArray } from '@lhb/func';

export interface BussinessStoreProps {
  detail?: any;
  setStoreChecked?: any;
  curDetail:any;
  setCurDetail:any;
  setStoreOptions?: any; // 所有展示项
  tenantId: any;
  drawerData?: any;
  spotEvaluationConfig: any;
  isALQ: boolean;
  coefficientVal: any; // 奥乐齐竞争系数
  handleALQDCompetitionCoefficients: (params: any) => void;
  enableBrandCompetitionDistinguish: boolean;
}

const BussinessStore: FC<BussinessStoreProps> = ({ detail, setCurDetail, setStoreOptions, tenantId, drawerData,
  spotEvaluationConfig,
  isALQ,
  coefficientVal,
  handleALQDCompetitionCoefficients,
  enableBrandCompetitionDistinguish,
  ...props }) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [filters, setFilters] = useState<{ [x: string]: any }>({});// 查询条件
  const [refreshCurrent, setRefreshCurrent] = useState<boolean>(false);// 是否需要当前页刷新
  const [loading, setLoading] = useState<boolean>(false);// 是否需要当前页刷新
  const [tableLoading, setTableLoading] = useState<boolean>(true);// 是否需要当前页刷新
  const [isNoData, setIsNodata] = useState<boolean>(false);// 是否没数据
  const [modColumn, setModColumn] = useState<any>({
    value: 'address',
    label: '地址'
  });// 表头修改
  // 奥乐齐专有的配置模块
  const showALQModule = useMemo(() => {
    return spotEvaluationConfig?.competitionCoefficientDisplay === 1 && !!isALQ;
  }, [spotEvaluationConfig?.competitionCoefficientDisplay, isALQ]);

  useEffect(() => {
    if (Object.keys(filters).length && Object.keys(detail).length && 'type' in filters) {
      setTableLoading(false);
      props.setStoreChecked && props.setStoreChecked(filters);
    }
  }, [filters, detail]);

  const methods = useMethods({

    // 搜索
    onSearch: (values: { [x: string]: string }) => {
      setFilters({ ...values });
    },

    /**
     * @description 从1页重新加载
     */
    reload() {
      setRefreshCurrent(false);
      setFilters({ ...filters });
    },

    loadData: async (params: any) => { // 初始化
      // 这里加这个是为了解决 在打开抽屉时立马关闭抽屉，导致的detail被销毁，但是代码有概率会执行到此，此时下面的params的detail拿不到值，传给接口，接口会报422
      if (!detail || !Object.keys(detail).length) {
        return {
          dataSource: [],
          count: 0
        };
      }
      let api: any = '';
      let _params: any = {};

      let newModColumn = { value: 'address', label: '地址' };
      const { type, modelClusterId, radius, modelConfigId } = drawerData;
      switch (filters.type + '') {
        case '1':
          // _params = {
          //   page: params.page,
          //   size: params.size,
          //   cityId: detail.cityId,
          //   categoryId: params.categoryId,
          //   lng: detail.lng,
          //   lat: detail.lat,
          //   tenantId,
          //   type: drawerData.type,
          //   modelClusterId: drawerData.modelClusterId,
          //   modelConfigId: drawerData.modelConfigId,
          // };
          _params = {
            page: params.page,
            size: params.size,
            cityId: detail.cityId,
            categoryId: params.categoryId,
            lng: detail.lng,
            lat: detail.lat,
            type,
            modelConfigId,
          };
          if (tenantId) {
            _params.tenantId = tenantId;
          }
          if (type === SpotTypeEnum.Mall) {
            _params.modelClusterId = modelClusterId;
          }
          if (type === SpotTypeEnum.Street) {
            _params.poiSearchType = detail?.poiSearchType;
            _params.radius = detail?.radius;
            _params.poiSearchMinute = detail?.poiSearchMinute;
            _params.poiSearchDistance = detail?.poiSearchDistance;
            _params.points = detail?.points;
          }
          api = tenantId ? famousBrandDataListShare : getSpotEvaluationFamousBrandPage;

          newModColumn = { value: 'brandName', label: '品牌名称' };
          break; // 知名品牌
        case '2':
          _params = {
            page: params.page,
            size: params.size,
            cityId: detail.cityId,
            lng: detail.lng,
            lat: detail.lat,
            // tenantId,
            type: drawerData.type,
            // modelClusterId: drawerData.modelClusterId,
            modelConfigId: drawerData.modelConfigId,
            statusList: params.secondLevelCode ? [params.secondLevelCode] : undefined,
            competitionBrandTypes: isArray(filters.thirdLevelCode) ? filters.thirdLevelCode : null,
            ...(enableBrandCompetitionDistinguish === true ? { competitionTypes: filters.competitionTypes || [] } : {})
          };
          // 选中了开闭店
          if (filters.isOpenCloseDate) { // 奥乐齐场景
          // 选中了开闭店
            filters.shopOpenCloseTimeTypes && (_params.shopOpenCloseTimeTypes = filters.shopOpenCloseTimeTypes);
          }
          // else { // 非奥乐齐时，只要有三级，就赋值给shopOpenCloseTimeTypes
          //   _params.shopOpenCloseTimeTypes = filters.thirdLevelCode;
          // }
          if (tenantId) {
            _params.tenantId = tenantId;
          }
          if (drawerData?.userId) {
            _params.userId = drawerData.userId;
          }
          if (type === SpotTypeEnum.Mall) {
            _params.modelClusterId = modelClusterId;
          }
          if (type === SpotTypeEnum.Street) {
            _params.radius = radius;
            _params.points = detail?.points;
          }

          api = tenantId ? surroundCompetitorsPagePOIDataListShare : postSpotEvaluationCompetitorsPage;

          newModColumn = { value: 'brandName', label: '品牌名称' };
          break;
        default:
          _params = {
            page: params.page,
            size: params.size,
            lng: detail.lng,
            lat: detail.lat,
            filrstLevelCode: filters.filrstLevelCode,
            secondLevelCode: filters.secondLevelCode,
            thirdLevelCode: filters.thirdLevelCode,
            tenantId,
            type: drawerData.type,
            // modelClusterId: drawerData.modelClusterId,
            modelConfigId: drawerData.modelConfigId,
          };
          if (tenantId) {
            _params.tenantId = tenantId;
          }
          if (type === SpotTypeEnum.Mall) {
            _params.modelClusterId = modelClusterId;
          }
          if (type === SpotTypeEnum.Street) {
            _params.poiSearchType = detail?.poiSearchType;
            _params.radius = detail?.radius;
            _params.poiSearchMinute = detail?.poiSearchMinute;
            _params.poiSearchDistance = detail?.poiSearchDistance;
            _params.points = detail?.points;
          }
          api = tenantId ? spotEvaluationLevelPageShare : spotEvaluationLevelPage;

          newModColumn = { value: 'address', label: '地址' };
          break;
      }
      const data = await api(_params, false).finally(() => {
        setLoading(false);
      });
      const { objectList } = data;

      setModColumn(newModColumn);
      console.log(`loading = `, loading, objectList);

      return {
        dataSource: objectList.map((item, index) => {
          item.index = (params.page - 1) * params.size + index + 1;
          return item;
        }),
        count: data.totalNum,
      };

    },
  });

  return isNoData ? <></> : (
    <div className={styles['store']} >
      <V2Title divider type='H2' text={`经营门店`}/>
      <Search
        onSearch={methods.onSearch}
        detail={detail}
        setCurDetail={setCurDetail}
        tenantId={tenantId}
        setIsNodata={setIsNodata}
        setStoreOptions={setStoreOptions}
        drawerData={drawerData}
        showALQModule={showALQModule}
        coefficientVal={coefficientVal}
        handleALQDCompetitionCoefficients={handleALQDCompetitionCoefficients}
        enableBrandCompetitionDistinguish={enableBrandCompetitionDistinguish}
      />
      {!tableLoading ? <TableList
        mainHeight={521}
        filters={filters}
        onFetch={methods.loadData as any}
        refreshCurrent={refreshCurrent}
        curDetail={props?.curDetail}
        modColumn={modColumn}
        rowClassName={(record) => {
          return (record.name === props?.curDetail?.name && record.address === props?.curDetail?.address) ? 'checked pointer' : 'pointer';
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              setCurDetail(record);
              // bigdataFn('23629346-0e01-4a33-885e-8149a2cfeb86', '详情-经营门店列表-点击列表', '点击了详情-经营门店列表-点击列表', { op_block: '开店区域-详情页', op_event: ``, });
            }, // 点击行
          };
        }}
        onPaginationChange={() => {
          // bigdataFn('c2af9054-3309-4490-a301-a8837c867a04', '详情-经营门店列表-列表跳页', '点击了详情-经营门店列表-列表跳页', { op_block: '开店区域-详情页', op_event: ``, });
        }}
      /> : ''}
    </div>
  );
};

export default BussinessStore;
